import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initInstallCapture } from "./lib/installPrompt";
import { registerServiceWorker } from "./lib/push";

initInstallCapture();
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => { registerServiceWorker(); });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
